import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

export const COMPANY_TIMEZONES: Record<string, string> = {
  MY: 'Asia/Kuala_Lumpur', // UTC+8
  ID: 'Asia/Jakarta', // UTC+7
  VN: 'Asia/Ho_Chi_Minh', // UTC+7
};

export const getCompanyTimeZone = (countryCode?: string): string => {
  if (!countryCode) return 'Asia/Kuala_Lumpur';
  return COMPANY_TIMEZONES[countryCode] || 'Asia/Kuala_Lumpur';
};

// Converts UTC → company local time
export const toCompanyLocalTime = (utcDate: Date | string, tz: string) => {
  const date = typeof utcDate === 'string' ? new Date(utcDate) : utcDate;
  const utcNow = new Date(date.toISOString());
  return utcToZonedTime(utcNow, tz);
};

// Converts company local → UTC
export const toUTC = (localDate: Date, tz: string) => zonedTimeToUtc(localDate, tz);
